import { useSelector } from "react-redux";
import { StateExtended } from "../../_config/interfaces/stateExtended";

export const useCategoriesSelector = () => useSelector((state: StateExtended) => state.categories.categories);
